import React from "react"
import { SpecificActionComponentProps } from "../../types"
import { IconButton } from "../../../../../mp-shared-components/generic-shared-components/components"
import { FaIcon } from "../../../../../mp-core/icons"
import { Tooltip } from "../../../../../mp-shared-components/ready-shared-components/components"
import { useGenerateStudentPerformanceReport } from "../../../../hooks/studentPerformanceReport/useGenerateStudentPerformanceReport"
import downloadUrl from "../../../../../mp-core/helpers/downloadUrl"

const StudentReportAction: React.FC<SpecificActionComponentProps> = ({
  record,
  actionOption
}) => {
  const { loading, generateReport } = useGenerateStudentPerformanceReport()

  const onClick = async () => {
    const result = await generateReport(
      record.id,
      record.studentId,
      record.name
    )

    if (!result?.url) {
      return
    }

    downloadUrl(result.url, result.fileName)
  }

  return (
    <Tooltip
      size="md"
      title={actionOption.tooltip}
      tooltipClasses={{ tooltip: "clarity-mask" }}
    >
      <IconButton size="xsmall" disabled={loading} onClick={onClick}>
        <FaIcon
          solid
          spin={loading}
          name={loading ? "circle-notch" : actionOption.icon}
        />
      </IconButton>
    </Tooltip>
  )
}

export default StudentReportAction
